import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Tabs, Tab, DropdownButton, Dropdown } from 'react-bootstrap';  // Button, Form, Row, Col, Card, Accordion, Tabs, Tab, Badge, Table
import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
import { IconContext } from "react-icons";
import { useHttp } from '../../hooks/http.hook'
import { AuthContext } from '../../context/AuthContext'
import { LanguagesContext } from "../../context/LanguagesContext";
import { Gender } from '../../constants';

import { AddUserBlock } from './AddUserBlock';
import { UsersTable } from './UsersTable';
import { LessonsList } from './LessonsList';

import { TeamCaptionBlock } from './TeamCaptionBlock';


import '../css/ContentPages.css';
import { Roles } from '../../hooks/auth.hook';
import { Loader } from '../components/Loader';

export const TeamCard = ({ team, array, index, changeTeamIndex, saveTeamNameChanges, deleteTeam, dropdownLessons, setReceivedError, selectedClient, showAllLanguages = false }) => {

    const { token } = useContext(AuthContext)
    const { pageLanguage, activeLanguage } = useContext(LanguagesContext)
    const { request } = useHttp()

    //const { activeLanguage } = useContext(LanguagesContext); //pageLanguage

    const [users, setUsers] = useState([])
    const [teamLessons, setTeamLessons] = useState([])
    const [teamActiveState, setTeamActiveState] = useState(team.active === 1)
    const [loading, setLoading] = useState(false)

    const fetchUsers = useCallback(async () => {
        let path = `/team/${team.id}/users`
        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })
            if (fetched) {
                //console.log(fetched.users);
                setUsers(fetched)
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, team, setReceivedError])

    const fetchLessons = useCallback(async () => {
        let path = `/team/${team.id}/lessons`
        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })
            if (fetched?.length > 0) {
                setTeamLessons(fetched);
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, team, setReceivedError])

    useEffect(() => {
        fetchUsers();
        fetchLessons();
    }, [fetchUsers, fetchLessons])

    const addUsers = async (newUsers) => {
        try {
            const newUsersData = await request('/user/add', 'POST', {
                team_id: team.id,
                client_id: selectedClient?.id,
                requestedRole: Roles.User,
                users: newUsers,
            }, {
                'x-access-token': token
            })
            //console.log('error ', error);            
            setUsers(prevUsers => [...prevUsers, ...newUsersData])
            console.log(users);
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteUser = async (user) => {

        try {
            const data = await request(`/user/remove/${user.id}`, 'GET', null, {
                'x-access-token': token
            })
            //console.log('error ', error);
            if (Number.isInteger(data?.changed)) {
                setUsers(users => users.filter(item => item.id !== user.id))
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteUsers = async (userIds) => {
        try {
            const data = await request('/user/remove', 'POST', { userIds }, {
                'x-access-token': token
            });

            if (Number.isInteger(data?.changed)) {
                setUsers(users => users.filter(item => !userIds.includes(item.id)));
            }
        } catch (e) {
            setReceivedError(e)
        }
    };

    const toogleTeamActivation = async () => {
        let newValue = teamActiveState ? 0 : 1;
        try {
            const result = await request(`/team/${team.id}/activate/${newValue}`, 'GET', null, {
                'x-access-token': token
            })
            //console.log(data);

            if (result?.affectedRows > 0)
                setTeamActiveState(!teamActiveState);

        } catch (e) {
            console.log('error ', e);
            setReceivedError(e)
        }
    }

    const moveUserFromTeam = () => {
        console.log('moveUserFromTeam: not implemented');
    };

    const importUsers = async (file) => {
        setLoading(true);

        try {
            const text = await file.text();
            const rows = text.split('\n');
            const headers = rows[0].split(',');
            const genderMapper = {
                male: Gender.Male,
                female: Gender.Female,
                other: Gender.NotBinary,
            };

            const users = rows.slice(1).reduce((acc, row) => {
                if (!row) return acc;

                const values = row.split(',');
                const user = {};

                headers.forEach((header, index) => {
                    const key = header.trim().toLowerCase();
                    const value = values[index].trim();

                    if (key === 'gender') {
                        user[key] = genderMapper[value.toLowerCase()] ?? Gender.Unknown;
                        return;
                    }

                    if (key === 'role') {
                        user['company_role'] = value;
                        return;
                    }

                    user[key] = value;
                });

                return acc.concat(user);
            }, []);

            await addUsers(users);
        } catch (e) {
            setReceivedError(e)
        } finally {
            setLoading(false);
        }
    }

    const addLessonToTeam = async (lesson) => {
        // try request /:teamId/link_lesson/:lessonId
        try {
            const data = await request(`/team/link_lesson`, 'POST', { lessonId: lesson.id, teamId: team.id }, {
                'x-access-token': token
            })

            if (data) {
                setTeamLessons([...teamLessons, data])
            }
        }
        catch (e) {
            setReceivedError(e)
        }
    }

    const deleteLesson = async (lesson) => {
        // try request /:teamId/unlink_lesson/:lessonId
        try {
            const data = await request(`/team/unlink_lesson`, 'POST', { lessonId: lesson.id, teamId: team.id }, {
                'x-access-token': token
            })

            if (data?.affectedRows > 0) {
                setTeamLessons(teamLessons.filter(item => item.lesson_id !== lesson.id))
            }
        }
        catch (e) {
            setReceivedError(e)
        }
    }

    const lessonActivationHandler = async (lesson, state) => {
        try {
            const data = await request(`/team/${team.id}/activate_lesson/`, 'POST', { lessonId: lesson.id, state: state }, {
                'x-access-token': token
            })

            if (data?.affectedRows > 0) {
                setTeamLessons(teamLessons.map(item => {
                    if (item.lesson_id === lesson.id)
                        return { ...item, active: state }

                    return item;
                }));
            }
        } catch (e) {
            setReceivedError(e)
        }
    };


    return (
        <div className="CardBlock BoxShadow mb-5" key={team.id}>
            <Tabs className={`CardBlockHeder ${teamActiveState ? '' : 'bg-info'}`} defaultActiveKey="users_content">
                {changeTeamIndex !== null && (
                    <Tab
                        tabClassName="CardBlockHederTabArrows"
                        title={
                            <div className="d-flex flex-column ">
                                <IconContext.Provider value={{ color: "#ccc" }}>
                                    {array[index - 1] && <FaSortUp onClick={() => changeTeamIndex(team.id, array[index - 1].id)} />}
                                    {array[index + 1] && <FaSortDown onClick={() => changeTeamIndex(array[index + 1].id, team.id)} />}
                                </IconContext.Provider>
                            </div>
                        }
                    />)}

                <Tab
                    tabClassName="CardBlockHederTabName"
                    title={
                        <div className='d-flex ml-3'>
                            <TeamCaptionBlock
                                lesson={team} save={saveTeamNameChanges} pagelanguage={pageLanguage}
                                activelanguage={activeLanguage} teamActiveState={teamActiveState} editableName={true}
                                showAllLanguages={showAllLanguages}
                            />
                        </div>
                    }
                />
                <Tab
                    tabClassName="CardBlockHederTab"
                    eventKey="users_content"
                    title={`Users ${users.length > 0 ? `(${users.length})` : ''}`}
                >
                    <div className='d-flex'>
                        <AddUserBlock activeLanguage={activeLanguage} addUser={addUsers} importUsers={importUsers} />
                    </div>

                    <UsersTable users={users} deleteUser={deleteUser} deleteUsers={deleteUsers} teamId={team.id} setReceivedError={setReceivedError} />

                    {loading && <Loader />}

                </Tab>
                <Tab
                    tabClassName="CardBlockHederTab"
                    eventKey="lessons_content"
                    title={`Lessons ${teamLessons?.length > 0 ? `(${teamLessons?.length})` : ''}`}
                >
                    {(dropdownLessons?.length)
                        ? <div className='d-flex m-3'>
                            <h3 className="FormSubTitle mr-3">Add Lesson: </h3>
                            <DropdownButton id="dropdown-basic-button" variant="info" title="Select"
                                className="mr-2 BoxShadowSelect FormText">
                                {dropdownLessons
                                    .filter(lesson => !teamLessons.find(tl => tl.lesson_id === lesson.id))
                                    .map((lesson, index) =>
                                        <Dropdown.Item key={lesson.id} onClick={() => addLessonToTeam(lesson)}
                                            className="FormTextDark BoxShadow">
                                            {activeLanguage.filter(lang => lesson["name_" + lang.code])
                                                .map(lang => lesson["name_" + lang.code]).join("|")}
                                        </Dropdown.Item>
                                    )}
                            </DropdownButton>
                        </div>
                        :
                        <span className="FormText m-3">No Available Lessons to Add</span>}

                    {teamLessons?.length > 0 ?
                        <LessonsList lessons={
                            teamLessons.map(tl => {
                                let l = dropdownLessons.find(dl => dl.id === tl.lesson_id);
                                l.active = tl.active;
                                l.index = tl.index;
                                return l;
                            })
                        } activeLanguage={activeLanguage} deleteLesson={deleteLesson} lessonActivationHandler={lessonActivationHandler} /> :
                        <span className="FormText m-3">No added lessons</span>}
                </Tab>



                {deleteTeam !== null && (<Tab
                    tabClassName="CardBlockHederTabTresh CenterLessons"
                    title={
                        <div>
                            <button className={`btn btn-sm mr-3 ${teamActiveState ? 'btn-light' : 'btn-success'}`}
                                onClick={() => { toogleTeamActivation() }}>{teamActiveState ? 'Disable' : 'Enable'}</button>
                            <img src="/img/Trash.png" alt="" className="CardBlockHederImgSmall" onClick={() => {
                                if (window.confirm('Delete this item?')) {
                                    deleteTeam(team.id)
                                }
                            }} />
                        </div>
                    }
                />)}

            </Tabs>
        </div >
    );
}
